import api from './api';
export const credentialService = {
    shopifyStore(data) {
        return api.post('/api/store/connect', {
            platform: 'shopify',
            ...data,
        });
    },
    bigCommerceStore(data) {
        return api.post('/api/store/connect', {
            platform: 'bigcommerce',
            ...data,
        });
    },
    walmartStore(data) {
        return api.post('/api/store/connect', {
            platform: 'walmart',
            ...data,
        });
    },
};
